import { checkObjectForKey } from "components/Shared/Functions";
import {
  PhotoTagSetting,
  PhotoButtonSetting,
  PhotoNumberingSetting,
  PhotoSizeSetting
} from "typeConstants/preferenceTypes";

export const photoToolButtonHoverOptions = {
  SHOW_ON_HOVER: "1",
  SHOW_ALWAYS: "2",
};

export const photoToolPhotoNumberingOptions = {
  SHOW_NUMBERS_ALWAYS: "SHOW_NUMBERS_ALWAYS",
  SHOW_ON_HOVER: "SHOW_ON_HOVER",
  HIDE_NUMBERS: "HIDE_NUMBERS",
};

export const photoTagHoverSettings = {
  HIDE: "0",
  HOVER: "1",
  SHOW: "2"
};

export type PhotoSizeMeta = {
  label: string;
  preferenceCode: string;
  dimensions: {
    width: number;
    height: number;
  };
  showsPhotoTags: boolean;
  maxPhotoTags?: number;
};

// The chips take up 25 pixels between the size of the chip itself and the gap in between. Beware of changing the maxPhotoTags property values
// We don't do any tags for extra small, it's too tiny to show any tags at all
export const photoSizeMetaData: Record<string, PhotoSizeMeta> = {
  EXTRA_SMALL: {
    label: "Extra Small",
    preferenceCode: "EXTRA_SMALL",
    dimensions: {
      width: 100,
      height: 75,
    },
    showsPhotoTags: false,
  },
  SMALL: {
    label: "Small",
    preferenceCode: "SMALL",
    dimensions: {
      width: 200,
      height: 150,
    },
    showsPhotoTags: true,
    maxPhotoTags: 6,
  },
  MEDIUM: {
    label: "Medium",
    preferenceCode: "MEDIUM",
    dimensions: {
      width: 400,
      height: 300,
    },
    showsPhotoTags: true,
    maxPhotoTags: 12,
  },
  LARGE: {
    label: "Large",
    preferenceCode: "LARGE",
    dimensions: {
      width: 600,
      height: 450,
    },
    showsPhotoTags: true,
    maxPhotoTags: 18,
  },
  EXTRA_LARGE: {
    label: "Extra Large",
    preferenceCode: "EXTRA_LARGE",
    dimensions: {
      width: 800,
      height: 600,
    },
    showsPhotoTags: true,
    maxPhotoTags: 24,
  },
};

export const getPhotoTagSetting = preferences => {
  return checkObjectForKey(preferences, PhotoTagSetting) && preferences.PhotoTagSetting.value
    ? preferences.PhotoTagSetting.value
    : photoTagHoverSettings.HOVER;
};

export const getPhotoNumbersSetting = preferences => {
  return checkObjectForKey(preferences, PhotoNumberingSetting) && preferences.PhotoNumberingSetting.value
    ? preferences.PhotoNumberingSetting.value
    : photoToolPhotoNumberingOptions.SHOW_NUMBERS_ALWAYS;
};

export const getPhotoButtonHoverSetting = preferences => {
  return checkObjectForKey(preferences, PhotoButtonSetting) && preferences.PhotoButtonSetting.value
    ? preferences.PhotoButtonSetting.value
    : photoToolButtonHoverOptions.SHOW_ON_HOVER;
};

export const getPhotoSizeSetting = (preferences): PhotoSizeMeta => {
  return checkObjectForKey(preferences, PhotoSizeSetting) && preferences.PhotoSizeSetting.value
    ? photoSizeMetaData[preferences.PhotoSizeSetting.value]
    : photoSizeMetaData.MEDIUM;
};
